import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { AccountContract } from './account-contract.model';
import * as AccountActions from './account.actions';
import { Account } from './account.model';

export const accountsFeatureKey = 'accounts';

export interface State extends EntityState<Account> {
    ARContracts: AccountContract[];
}

export const adapter: EntityAdapter<Account> = createEntityAdapter<Account>({
    selectId: (model: Account) => model.AccountListID
});

export const initialState: State = adapter.getInitialState({
    ARContracts: []
});

const accountReducer = createReducer(
    initialState,
    on(AccountActions.addAccount, (state, action) =>
        adapter.addOne(action.account, state)
    ),
    on(AccountActions.upsertAccount, (state, action) =>
        adapter.upsertOne(action.account, state)
    ),
    on(AccountActions.addAccounts, (state, action) =>
        adapter.addMany(action.accounts, state)
    ),
    on(AccountActions.upsertAccounts, (state, action) =>
        adapter.upsertMany(action.accounts, state)
    ),
    on(AccountActions.updateAccount, (state, action) =>
        adapter.updateOne(action.account, state)
    ),
    on(AccountActions.updateAccounts, (state, action) =>
        adapter.updateMany(action.accounts, state)
    ),
    on(AccountActions.deleteAccount, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(AccountActions.deleteAccounts, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(AccountActions.loadAccounts, (state, action) =>
        adapter.setAll(action.accounts, state)
    ),
    on(AccountActions.clearAccounts, state => adapter.removeAll(state)),
    on(AccountActions.loadContractARAccounts, (state, action) => {
        return {
            ...state,
            ARContracts: action.contracts
        };
    }),
    on(AccountActions.updateContractARAccounts, (state, action) => {
        return {
            ...state,
            ARContracts: [
                ...state.ARContracts.filter(
                    x =>
                        !action.contracts
                            .map(y => y.Contractlistid)
                            .includes(x.Contractlistid)
                ),
                ...action.contracts
            ]
        };
    })
);

export function reducer(state: State | undefined, action: Action) {
    return accountReducer(state, action);
}
